import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { Http } from '@angular/http';
import CustomStore from 'devextreme/data/custom_store';
import { NTECH_API } from './../app.api';
import { GridConfig, adicionaIconesGrid, calculaAlturaGrid } from './../app.config';
import { DxDataGridModule, DxDataGridComponent } from 'devextreme-angular';

@Component({
  selector: 'ntc-pais',
  templateUrl: './pais.component.html',
  styleUrls: ['./pais.component.css']
})
export class PaisComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;

  showFilterRow = GridConfig.showFilterRow;
  currentFilter = GridConfig.currentFilter;
  showHeaderFilter = GridConfig.showHeaderFilter;
  columnChooser = GridConfig.columnChooser;
  groupPanel = GridConfig.groupPanel;
  searchPanel = GridConfig.searchPanel;
  exportGrid = GridConfig.exportGrid;

  editOptionsGridPais = null;
  colunasGridPais = null;
  pais = null;
  alturaGrid = null;

  constructor(@Inject(Http) http: Http) {

    this.pais = new CustomStore({
      insert: function (values) {
        return http.post(`${NTECH_API}/pais/`, values).toPromise();
      },
      remove: function (key) {
        return http.delete(`${NTECH_API}/pais/${encodeURIComponent(key.Id)}`).toPromise();
      },
      update: function (key, values) {
        return http.put(`${NTECH_API}/pais/${encodeURIComponent(key.Id)}`, Object.assign(key, values)).toPromise();
      },
      load: function (loadOptions: any) {
        return http.get(`${NTECH_API}/pais/`)
            .toPromise()
            .then(response => response.json())
            .catch(error => { throw 'Erro ao carregar dados.' });
      }
    });

    this.colunasGridPais = [
      {
        dataField: 'Id',
        dataType: 'string',
        caption: 'ID',
        editorOptions: { disabled: true }
      },
      {
        dataField: 'NomePais',
        dataType: 'string',
        caption: 'Nome País',
        validationRules: [{
          type: 'required',
          message: 'Nome do País é obrigatório.'
        }]
      },
      {
        dataField: 'DDI',
        dataType: 'string',
        caption: 'DDI',
        validationRules: [{
          type: 'required',
          message: 'DDI do País é obrigatório.'
        }]
      },
      {
        dataField: 'SiglaPais',
        dataType: 'string',
        caption: 'Sigla País',
        validationRules: [{
          type: 'required',
          message: 'Sigla do País é obrigatório.'
        }]
      }
    ];

    this.editOptionsGridPais = {
      mode: GridConfig.gridMode, // form
      allowUpdating: true,
      allowAdding: true,
      allowDeleting: true,
      popup: {
        title: 'Pais',
        showTitle: true
      }
    };
  }

  onCellPrepared(e) {
    adicionaIconesGrid(e);
  }

  onToolbarPreparing(e) {
    const toolbarItems = e.toolbarOptions.items;

    // Adiciona um novo botao a Toolbar
    toolbarItems.push({
      location: 'after',
      widget: 'dxButton',
      options: {
          icon: 'refresh',
          onClick: this.refreshDataGrid.bind(this)
      }
    });
  }

  refreshDataGrid() {
    this.dataGrid.instance.refresh();
  }

  ngOnInit() {
    this.alturaGrid = calculaAlturaGrid();
  }

}



// WEBPACK FOOTER //
// ./src/app/pais/pais.component.ts